import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { useSkin } from "@/lib/skin";

export default function Layout() {
  const dark = useSkin() === "dark";
  useEffect(() => { document.documentElement.dataset.skin = dark ? "dark" : "classic"; }, [dark]);
  return (
    <div className={`App min-h-screen flex flex-col ${dark ? "bg-[#0A0A0B] skin-dark" : "bg-white"}`} data-skin={dark ? "dark" : "classic"}>
      <Header />
      <main className="flex-1 pt-20" data-testid="main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
